import { render, staticRenderFns } from "./CreditNoteList.vue?vue&type=template&id=6222a3ea&scoped=true"
import script from "./CreditNoteList.vue?vue&type=script&lang=js"
export * from "./CreditNoteList.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteList.vue?vue&type=style&index=0&id=6222a3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6222a3ea",
  null
  
)

export default component.exports